import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="mb-6 overflow-x-auto whitespace-nowrap scrollbar-none">
      <ol className="flex items-center gap-1.5 min-w-min">
        <li>
          <Link 
            to="/" 
            className="text-white/50 hover:text-white text-sm transition-colors"
          >
            Ana Sayfa
          </Link>
        </li>

        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-1.5">
            <ChevronRight className="w-4 h-4 text-white/30" />
            {index === items.length - 1 ? (
              <span className="text-white text-sm">
                {item.name}
              </span>
            ) : (
              <Link
                to={item.path}
                className="text-white/50 hover:text-white text-sm transition-colors"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}